module.exports = __webpack_public_path__ + "static/media/grill.43a5bc38.png";